import { forwardRef, useEffect, useState } from 'react'
import styles from './header.module.css'
import clsx from 'clsx'
import { MeshAvatar } from '../common'
import { ReactComponent as ArrowDownIcon } from '../../assets/keyboard_arrow_down_icon.svg'
import { useMessagingService } from '../../agent'
import { HumanProxy, HumanProxyType } from '../../types'

type Props = {
  onClick: () => void
  isActive: boolean
  'aria-pressed'?: boolean
}

export const MenuButton = forwardRef<HTMLDivElement, Props>(
  ({ onClick, isActive, ...rest }, ref) => {
    const messagingService = useMessagingService()
    const [humanProxy, setHumanProxy] = useState<HumanProxy | undefined>(
      undefined,
    )

    useEffect(() => {
      messagingService.listHumanProxies().then(it => {
        const payload = it.payload
        const personalProxy = payload?.humanProxies.find(
          it => it.type === HumanProxyType.persona,
        )
        setHumanProxy(personalProxy)
      })
    }, [messagingService])

    const { friendlyName, avatar } = humanProxy?.profile || {}

    return (
      <div
        ref={ref}
        className={clsx(styles.menuButton, isActive && styles.menuButtonActive)}
        onClick={onClick}
        {...rest}
      >
        <div>
          <MeshAvatar imageUrl={avatar?.imageUrl} name={friendlyName} />
        </div>
        <div>{friendlyName}</div>
        <ArrowDownIcon className={styles.arrowDownIcon} />
      </div>
    )
  },
)

MenuButton.displayName = 'MenuButton'
